var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_235067",
    "data-name": "Group 235067",
    transform: "translate(-135 -599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_67881",
    "data-name": "Rectangle 67881",
    d: "M4,0H66a0,0,0,0,1,0,0V22a0,0,0,0,1,0,0H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(135 599)",
    fill: "#93ffb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_235061",
    "data-name": "Group 235061",
    transform: "translate(-14 -101)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Installed",
    transform: "translate(167 715)",
    fill: "#301a55",
    fontSize: 12,
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "Installed"), /*#__PURE__*/React.createElement("path", {
    id: "Path_214931",
    "data-name": "Path 214931",
    d: "M3.852,0A3.852,3.852,0,1,0,7.7,3.852,3.852,3.852,0,0,0,3.852,0M6.446,2.553,3.783,5.216h0l-.737.737h0L2.31,5.217,1.257,4.165a.229.229,0,0,1,0-.323l.414-.414a.229.229,0,0,1,.323,0l.891.891a.229.229,0,0,0,.323,0l2.5-2.5a.229.229,0,0,1,.323,0l.413.413a.229.229,0,0,1,0,.323",
    transform: "translate(155 707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.2d7ed03826b7ba2a3164782bad5bb2dd.svg";
export { ForwardRef as ReactComponent };